


















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Message } from "../models/message";
import ContactTypeLabel from "./ContactTypeLabel.vue";
import moment from "moment";

@Component({
  components: { ContactTypeLabel }
})
export default class MessageMetaCard extends Vue {
  @Prop({ required: true, type: Object }) public value!: Message;

  private get createdAt(): string {
    return moment(this.value.created_at).fromNow();
  }

  private openCard(): void {
    this.$compenda.getRelation(this.value.relation_id);
  }
}
